<template>
  <div v-if="show" class="video-label">
    <span class="video-label-text">{{ text }}</span>
  </div>
</template>

<script>
import VideoLabelMixin from '../mixins/VideoLabelMixin';

export default {
  name: 'VideoLabel',
  mixins: [VideoLabelMixin],
};
</script>

<style></style>
